import { useNavigate } from "react-router-dom";
import Noty from "noty";
import { t } from "i18next";

function useErrorHandler() {
  const navigate = useNavigate();
  return (error: any, setBackendFormErrors: any = null) => {
    if (error.response.status === 401) {
      new Noty({
        text: t(error.response.data.error) ?? "",
        theme: "relax",
        type: "error",
        layout: "topCenter",
        timeout: 6000,
      }).show();
      if (error.response.data.error === "Unauthenticated.") {
        navigate("/login");
      }
    } else if (error.response.status === 422) {
      let formattedError = formatErrors(error.response.data.errors);
      setBackendFormErrors(formattedError);
    } else {
      new Noty({
        text: t(error.response.data.message) ?? "",
        theme: "relax",
        type: "error",
        layout: "topCenter",
        timeout: 6000,
      }).show();
    }
  };
}

function formatErrors(errors: any) {
  let formattedErrors: any = {};
  for (let key in errors) {
    // si key no contiene un punto, es un error del formulario
    if (!key.includes(".")) {
      formattedErrors[key] = { __errors: errors[key] };
      continue;
    } else {
      // Tenemos que de forma dinamica sacar las keys de key separando por punto y setear el objeto de formattedErrores con las keys sacadas y en la ultima key guardar el error
      let keys = key.split(".");
      let lastKey = keys.pop();
      let currentObject = formattedErrors;
      keys.forEach((key) => {
        if (!currentObject[key]) {
          currentObject[key] = {};
        }
        currentObject = currentObject[key];
      });
      if (lastKey) {
        currentObject[lastKey] = { __errors: errors[key] };
      }
    }
  }
  return formattedErrors;
}

export default useErrorHandler;
